module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("aGaBt"))).then(() => parcelRequire('8GCmY'));